import { useEffect } from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { updateDepartmentField } from "redux/slices/PageMemory/StocksDepartmentPageSlice";
import { RootState } from "redux/store";

type SelectSubDepartmentPopupProps = {
	show: boolean;
	subDepartmentId: string;
	onClose: () => void;
	onContinue: () => void;
};

export function SelectSubDepartmentPopup(props: SelectSubDepartmentPopupProps) {
	const dispatch = useAppDispatch();
	const stockDepartmentPageSlice = useAppSelector((state: RootState) => state.stockDepartmentPageSlice);

	useEffect(() => {
		if (props.subDepartmentId) {
		//	dispatch(getStocks(props.subDepartmentId));
			}
	}, []);	

	function handleChange(key: string, value: any) {
		dispatch(updateDepartmentField({ key: key, value: value }));
	}

	return (
		<Modal centered backdrop="static" show={props.show} onHide={props.onClose}>
			<Modal.Header>
				<Modal.Title>Select a Sub Department</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-3 mt-3">
					<Form.Select
						className="custom-select"
						onChange={(e) => handleChange("selectedSubDepartment", parseInt(e.target.value))}
						value={stockDepartmentPageSlice.selectedSubDepartment}
					>
						<option hidden value="">Choose a sub department</option>
						<option value=""></option>
						{stockDepartmentPageSlice.subDepartments.map((subdepartment: any, index: any) => {
							return <option key={index} value={subdepartment.id}>{subdepartment.name}</option>
						})}
					</Form.Select>
				</Form.Group>
				<Row>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={(e) => {
					props.onClose();
					handleChange("selectedSubDepartment", 0);
				}}>Cancel</Button>
				{stockDepartmentPageSlice.selectedSubDepartment !== 0 && <>
					<Button variant="primary" onClick={() => props.onContinue()}>Continue</Button>
				</>
				}
			</Modal.Footer>
		</Modal>
	);
}